import { useAuth } from '../../contexts/AuthContext'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import USER_TYPE from '../../constants/userType'
import ShopTable from '../../components/admin/ShopTable'
import { useFilters } from '../../hooks/useFilters'
import { FILTER_TYPES } from '../../constants/filters'

const DisplayWholesellers = () => {
  const { currentUser } = useAuth()
  const { renderFilters, filters, renderPagination } = useFilters()

  const { data: wholesellersData } = useQuery({
    queryKey: QueryKeys.adminListWholesellers(filters),
    queryFn: () => handleGetRequest(`/admin/wholesellers`, filters),
    enabled: currentUser?.userType === USER_TYPE.admin,
  })

  const wholesellers = wholesellersData?.data || []

  return (
    <>
      <div className="flex gap-6 mb-8">
        {renderFilters([
          FILTER_TYPES.search,
          FILTER_TYPES.isApproved,
          FILTER_TYPES.isActive,
          FILTER_TYPES.sort,
        ])}
      </div>
      <div className="border overflow-hidden w-full">
        <div className="overflow-x-auto">
          <ShopTable data={wholesellers} onView={(slug) => `/admin/wholesellers/${slug}`} />
        </div>
      </div>

      {renderPagination(wholesellersData?.meta)}
    </>
  )
}

export default DisplayWholesellers
